import React from 'react';
import { CheckCircle, Shield } from 'lucide-react';

import haccp from '../assets/images/certificaciones/HACCP-removebg-preview.png';

const Certificaciones = () => {

  return (
    <div className="bg-gray-50 py-20 px-8">
      {/* Header */}
      <div className="text-center mb-16">
        <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-6">
          Nuestra Certificación
        </h1>
        <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
          Nuestro compromiso con la calidad se refleja en las certificaciones internacionales más prestigiosas, 
          garantizando los más altos estándares en cada proceso.
        </p>
      </div>

      {/* Certificación Principal */}
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 overflow-hidden group">
          
          {/* Barra superior animada */}
          <div className="h-2 bg-gradient-to-r from-orange-500 to-orange-700 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-700 origin-left"></div>
          
          <div className="p-12">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              
              {/* Logo con efectos sutiles */}
              <div className="relative">
                <div className="absolute inset-0 bg-orange-100 rounded-3xl transform rotate-3 group-hover:rotate-6 transition-transform duration-500"></div>
                <div className="relative bg-white p-8 rounded-3xl shadow-lg group-hover:shadow-xl transition-all duration-300">
                  <img 
                    src={haccp} 
                    alt="HACCP"
                    className="w-32 h-32 md:w-40 md:h-40 object-contain transform group-hover:scale-110 transition-transform duration-500"
                  />
                </div>
                
                {/* Badge flotante */}
                <div className="absolute -top-3 -right-3 bg-gradient-to-r from-orange-500 to-orange-600 text-white p-3 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition-all duration-500 transform translate-y-2 group-hover:translate-y-0">
                  <Shield className="w-5 h-5" />
                </div>
              </div>

              {/* Contenido */}
              <div className="flex-1 text-center lg:text-left">
                <h2 className="text-4xl md:text-5xl font-bold text-gray-800 mb-4 group-hover:text-orange-700 transition-colors duration-300">
                  HACCP
                </h2>
                
                <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                  Sistema de Análisis de Peligros y Puntos Críticos de Control que garantiza 
                  la seguridad alimentaria mediante un enfoque preventivo y sistemático.
                </p>

                {/* Badges informativos */}
                <div className="flex flex-wrap justify-center lg:justify-start gap-4 mb-8">
                  <div className="flex items-center bg-yellow-50 text-yellow-700 px-4 py-2 rounded-full border border-yellow-200 hover:bg-yellow-100 transition-colors duration-300">
                    <CheckCircle className="w-4 h-4 mr-2" />
                    <span className="font-medium">Certificación Activa</span>
                  </div>
                  <div className="flex items-center bg-blue-50 text-blue-700 px-4 py-2 rounded-full border border-blue-200 hover:bg-blue-100 transition-colors duration-300">
                    <span className="font-medium">Estándar Internacional</span>
                  </div>
                  <div className="flex items-center bg-orange-50 text-orange-700 px-4 py-2 rounded-full border border-orange-200 hover:bg-orange-100 transition-colors duration-300">
                    <span className="font-medium">Calidad Alimentaria</span>
                  </div>
                </div>

                {/* Indicador de validez */}
                <div className="inline-flex items-center bg-gradient-to-r from-orange-600 to-orange-700 text-white px-6 py-3 rounded-xl font-semibold shadow-lg hover:shadow-xl hover:from-orange-700 hover:to-orange-800 transition-all duration-300 transform hover:scale-105">
                  <CheckCircle className="w-5 h-5 mr-3" />
                  Certificación Vigente
                </div>
              </div>
            </div>
          </div>

          {/* Línea de progreso sutil en la parte inferior */}
          <div className="h-1 bg-gray-100">
            <div className="h-full bg-gradient-to-r from-orange-500 to-orange-600 transform scale-x-0 group-hover:scale-x-100 transition-transform duration-1000 origin-left"></div>
          </div>
        </div>
      </div>

      {/* Información adicional */}
      <div className="text-center mt-16">
        <p className="text-gray-500 max-w-2xl mx-auto">
          Esta certificación avala nuestro sistema de gestión de seguridad alimentaria, 
          asegurando que todos nuestros procesos cumplan con los estándares internacionales más exigentes.
        </p>
      </div>
    </div>
  );
};

export default Certificaciones;